<template>
    <div class="tradeList">
        <!--头部-->
        <Header title="交易记录" :show-back="true"/>
        <div class="list">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    :offset="10"
                    finished-text="没有更多了"
                    @load="onLoad">
                <li class="list-item" v-for="(item,index) in pushListData" :key="index">
                    <dl>
                        <dd class>
                            <span class="label">来自ID：</span>
                            <span>{{hideAccount(item.to_user_name)}}</span>
                        </dd>
                        <dd>
                            <span class="label">数量：</span>
                            <span>{{item.num}}</span>
                        </dd>
                    </dl>
                    <dl>
                        <dd class>
                            <span class="label">价格：</span>
                            <span>{{item.price}}</span>
                        </dd>
                        <dd class>
                            <span class="label">时间：</span>
                            <span>{{formatDate(item.start_time,2)}}</span>
                        </dd>
                    </dl>
                    <dl>
                        <dd class>
                            <span class="label">交易类型：</span>
                            <span>{{item.type===1 ? "卖出" : "买入"}}</span>
                        </dd>
                        <dd class>
                            <span class="label">交易状态：</span>
                            <span>{{stateEvent(item.status)}}</span>
                        </dd>
                    </dl>
                </li>
            </van-list>
        </div>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        components: {
            Header
        },
        data() {
            return {
                page: 0,
                pushListData: [],
                total: null,
                loading: false,
                finished: false
            };
        },
        methods: {
            // 获取待确认的交易
            getPushList() {
                this.page++;
                this.ajax.post("appapi/push/pushList", {page: this.page, status: 0}).then(res => {
                    if (res.data.code === 1) {
                        console.log(res.data.data.data);
                        this.pushListData.push(...res.data.data.data);
                        this.total = res.data.data.total;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.pushListData.length >= this.total) {
                            console.log("加载完成");
                            this.finished = true;
                        }
                    }
                });
            },
            onLoad() {
                setTimeout(() => {
                    this.getPushList();
                }, 500);
            },
            stateEvent(state) {
                switch (state) {
                    case 1:
                        return "未确认";
                    case 3:
                        return "完成";
                    case -1:
                        return "撤销";
                }
            }
        }
    };
</script>

<style lang="scss">
    .tradeList {

        .list {
            padding: 20px 30px 30px;

            &-item {
                margin-bottom: 17px;
                background: #fff;
                padding: 40px 52px;
                border-radius: 20px;
                box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.4);

                dl {
                    @include flex();
                    font-size: 24px;
                    color: #999999;
                    margin-bottom: 18px;

                    dd {
                        flex: 1;
                    }

                    .label {
                        font-weight: bold;
                        color: #3e3e3e;
                    }
                }
            }
        }
    }
</style>
